module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="apexchat_question_type_multiple_choice_radio livechat_rd_fade_in_bottom_delay apexchat_qt_button_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n    tabindex="0" id="apexchat_question_type_multiple_choice_radio_parent_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n>\r\n    <input type="radio" name="apexchat_question_type_radio_group_' +
((__t = (messageId)) == null ? '' : __t) +
'"\r\n        id="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" value="' +
((__t = (name )) == null ? '' : __t) +
'" />\r\n    <label class="livechat_btn livechat_btn_hollow apexchat_question_type_multiple_choice_radio_label"\r\n        for="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n        <!-- <span>This span is needed to create the "checkbox" element</span> -->\r\n        <div class="livechat_btn_item livechat_btn_inner apexchat_text apexchat_question_type_multiple_choice_radio_label_align"\r\n            tabindex="0" id="apexchat_question_type_multiple_choice_radio_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n            style="' +
((__t = (rdPlusStyles )) == null ? '' : __t) +
' ">\r\n            ' +
((__t = (name )) == null ? '' : __t) +
'\r\n        </div>\r\n    </label>\r\n</div>';

}
return __p
}